module.exports = __webpack_public_path__ + "img/arrow-down.6717d918.svg";